export const prefixToYandex = (path: string): string => `/api/yandex/${path}`;
